import React, { useState } from "react";
import axios from "axios";
import styles from "../AppBundle.module.css";

const AppCreation = ({ onAppCreated, onClose }) => {
  const [packageId, setPackageId] = useState("");

  const [appInfo, setAppInfo] = useState({
    app_name: "",
    app_id: "",
    description: "",
    initial_version: "1.0.0",
  });
  const [appInfoGPlay, setAppInfoGPlay] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (field, value) => {
    setAppInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const fetchAppInformation = async () => {
    try {
      console.log("Fetching app information for package ID...");
      if (!packageId || packageId.trim() === "") {
        setError("Package Id is required");
        return;
      }

      setLoading(true);
      setError("");

      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.post(
        `${url}/auth/getAppInfofromGPlay`,
        { packageId },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const item = response.data.data;

      const importantInfo = {
        app_id: item.appId,
        app_name: item.title,
        description: item.description,
        current_version: item.version,
        app_icon: item.icon,
      };

      setAppInfoGPlay(importantInfo);
      console.log("Parsed App Info:", importantInfo);

      console.log("App information:", response.data);
    } catch (error) {
      console.error("Error fetching app:", error);
      setError(
        error.response?.data?.message ||
          "Failed to fetching app. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };


  const addApp = async() =>{
        try {
      console.log("Fetching app information for package ID...");
      if (!packageId || packageId.trim() === "") {
        setError("Package Id is required");
        return;
      }

      setLoading(true);
      setError("");

      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.post(
        `${url}/auth/addApp`,
        { packageId },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      alert('Your app has been added')

      console.log("App information:", response.data);
    } catch (error) {
      console.error("Error creating app:", error);
      setError(
        error.response?.data?.message ||
          "Failed to create app. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  const validateAppInfo = () => {
    const errors = [];

    if (!appInfo.app_name.trim()) {
      errors.push("App name is required");
    }
    if (!appInfo.app_id.trim()) {
      errors.push("App ID is required");
    }
    if (!/^\d+$/.test(appInfo.app_id.trim())) {
      errors.push("App ID must be a number");
    }
    if (!appInfo.description.trim()) {
      errors.push("Description is required");
    }

    const versionRegex = /^\d+\.\d+\.\d+$/;
    if (!versionRegex.test(appInfo.initial_version)) {
      errors.push("Initial version should be in format: x.x.x (e.g., 1.0.0)");
    }

    return errors;
  };

  const createApp = async () => {
    const validationErrors = validateAppInfo();
    if (validationErrors.length > 0) {
      setError(validationErrors.join(". "));
      return;
    }

    try {
      setLoading(true);
      setError("");

      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.post(
        `${url}/auth/createApp`,
        {
          app_name: appInfo.app_name.trim(),
          app_id: parseInt(appInfo.app_id.trim()),
          description: appInfo.description.trim(),
          initial_version: appInfo.initial_version.trim(),
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("App created:", response.data);

      if (onAppCreated) {
        onAppCreated(response.data.data);
      }

      // Close modal after successful creation
      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error("Error creating app:", error);
      setError(
        error.response?.data?.message ||
          "Failed to create app. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {false ? (
          <div>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>Create New App</h3>
              <button className={styles.closeButton} onClick={onClose}>
                ×
              </button>
            </div>

            <div className={styles.formGrid}>
              <div className={styles.formGroup}>
                <label className={styles.label}>App Name *</label>
                <input
                  type="text"
                  value={appInfo.app_name}
                  onChange={(e) =>
                    handleInputChange("app_name", e.target.value)
                  }
                  placeholder="Enter app name"
                  className={styles.input}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>App ID *</label>
                <input
                  type="number"
                  value={appInfo.app_id}
                  onChange={(e) => handleInputChange("app_id", e.target.value)}
                  placeholder="Enter app ID"
                  className={styles.input}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Initial Version *</label>
                <input
                  type="text"
                  value={appInfo.initial_version}
                  onChange={(e) =>
                    handleInputChange("initial_version", e.target.value)
                  }
                  placeholder="e.g., 1.0.0"
                  className={styles.input}
                />
              </div>
              <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                <label className={styles.label}>Description *</label>
                <textarea
                  value={appInfo.description}
                  onChange={(e) =>
                    handleInputChange("description", e.target.value)
                  }
                  placeholder="Enter app description"
                  rows="3"
                  className={styles.textarea}
                />
              </div>
            </div>

            {error && <div className={styles.errorMessage}>{error}</div>}

            <div className={styles.modalActions}>
              <button onClick={onClose} className={styles.secondaryButton}>
                Cancel
              </button>
              <button
                onClick={createApp}
                disabled={loading}
                className={styles.primaryButton}
              >
                {loading ? "Creating..." : "Create App"}
              </button>
            </div>
          </div>
        ) : (
          <>
            {appInfoGPlay ? (
              <div style={{ marginTop: 20 }}>
                <h2>App Information </h2>
                <p
                  style={{ opacity: 0.7, marginBottom: 20, fontWeight: "600" }}
                >
                  Package ID : {appInfoGPlay.app_id}
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    alignItems: "center",
                    marginBottom: 20,
                  }}
                >
                  <img
                    src={appInfoGPlay.app_icon}
                    alt="App Icon"
                    style={{ width: 80, height: 80, borderRadius: 12 }}
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <p style={{ fontWeight: "bold", marginBottom: 0 }}>
                      {appInfoGPlay.app_name}
                    </p>
                    Current version:{" "}
                    {appInfoGPlay.current_version}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 10,
                    justifyContent: "space-between",
                  }}
                >
                  <button
                    onClick={fetchAppInformation}
                    className={{
                      backgroundColor: "#FF5656",
                      color: "white",
                      padding: "10px",
                      borderRadius: 5,
                      border: "none",
                      cursor: "pointer",
                    }}
                    style={{
                      marginTop: 10,
                      backgroundColor: "#FF5656",
                      color: "white",
                      padding: "10px",
                      borderRadius: 5,
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Reset or change package Id
                  </button>
                  <button
                    onClick={addApp}
                    className={styles.primaryButton}
                    style={{ marginTop: 10 }}
                  >
                    Add {appInfoGPlay.app_name} +
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <h3>Enter package Id</h3>
                <input
                  type="text"
                  placeholder="Package Id"
                  className={styles.input}
                  value={packageId}
                  onChange={(e) => setPackageId(e.target.value)}
                />

                <button
                  onClick={fetchAppInformation}
                  className={styles.primaryButton}
                  style={{ marginTop: "10px" }}
                >
                  Submit
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AppCreation;
